import { useEffect, useState, useCallback } from "react";
import { api, errMsg } from "../lib/api";

export function useApi(path, client = api) {
  const [state, setState] = useState({ data: null, loading: !!path, error: null });
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!path) return undefined;
    let live = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    client
      .get(path)
      .then((r) => { if (live) setState({ data: r.data, loading: false, error: null }); })
      .catch((e) => { if (live) setState({ data: null, loading: false, error: errMsg(e) }); });
    return () => { live = false; };
  }, [path, tick, client]);

  const reload = useCallback(() => setTick((t) => t + 1), []);
  return { ...state, reload };
}
